import NestColor from './NestColour.svg';
import NestDark from './NestDark.svg';
import NestLight from './NestLight.svg';
export const nest = { color: NestColor, dark: NestDark, light: NestLight };
//# sourceMappingURL=index.js.map